import { Component, ViewEncapsulation, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { ApiService } from '../shared/api.service';


@Component({
  selector: 'app-big-banner',
  templateUrl: './big-banner.component.html',
  styleUrls: ['./big-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BigBannerComponent implements OnInit {
  deviceInfo: any;
  slides: any = [];
  slideConfig: any = {};
  imagenAsistente: String = './assets/img/bigBanner/slider-asistente-online.jpg';
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(private deviceService: DeviceDetectorService,
              private apiService: ApiService, public router: Router, @Inject(PLATFORM_ID) private platformId: any,
              public location: Location,
    ) {  }

  ngOnInit() {
    const isMobile = this.deviceService.isMobile();
    if (this.location.path() === '/asistente-virtual') {
      if (isMobile) {
        this.imagenAsistente = './assets/img/bigBanner/slider-asistente-online-m.jpg';
        this.slides = [
          { img: './assets/img/bigBanner/slider-asistente-online-m.jpg', alt: "Asistente online" },
        ];
      } else {
        this.imagenAsistente = './assets/img/bigBanner/slider-asistente-online.jpg';
        this.slides = [
          { img: './assets/img/bigBanner/slider-asistente-online.jpg', alt: "Asistente online" },
        ];
      }

      this.slideConfig = {
        "autoplay": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "arrows": true,
        "dots": false,
      };
    }
    else if (this.location.path() === '/agendamiento-de-hora') {
      if (isMobile) {
        this.slides = [
          { img: './assets/img/bigBanner/slider-agendar-hora-m_int.jpg', alt: "Agenda tu hora"}
        ];
      } else {
        this.slides = [
          { img: './assets/img/bigBanner/slider-agendar-hora_int.jpg', alt: "Agenda tu hora"}
        ];
      }

      this.slideConfig = {
        "autoplay": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "arrows": true,
        "dots": true,
      };
    }
    else {

      this.slides = this.apiService.configuracion.banner;


      this.slideConfig = {
        "autoplay": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "arrows": true,
        "dots": true,
      };
    }
  }


  slickInit(e) {
  }

  breakpoint(e) {
  }

  afterChange(e) {
  }

  beforeChange(e) {
  }
}
